import {join as _join} from 'lodash';

import {getSortingTerritories} from '@utils/countryHelpers';

import {prepareUsages} from '../../utils/clientGeoRestrictionsHelper';

export const columns = {
    'id': {
        label: 'ID',
        sorting: true,
        header: {
            align: 'center',
            isCollapsed: true,
        },
        content: {
            align: 'center',
        },
    },
    'usages': {
        label: 'Usage',
        sorting: (row) => prepareUsages(row.usages).map((deviceCategory) =>
            deviceCategory.name + ' > ' + _join(deviceCategory.way_of_transmissions, ' / ')
        ),
    },
    'countries': {
        label: 'Territories',
        sorting: (row) => getSortingTerritories(row),
    },
    'notes': {label: 'Notes', sorting: (row) => row.notes.capitalizeFirstLetter()},
    'actions': {
        label: 'Actions',
        header: {
            align: 'center',
        },
        content: {
            align: 'center',
        },
    },
};
